import { render, staticRenderFns } from "./logoTemplate.vue?vue&type=template&id=57fba750&scoped=true&"
import script from "./logoTemplate.vue?vue&type=script&lang=js&"
export * from "./logoTemplate.vue?vue&type=script&lang=js&"
import style0 from "./logoTemplate.vue?vue&type=style&index=0&id=57fba750&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fba750",
  null
  
)

export default component.exports